import TaskPill from "@/components/TaskPill"
import BookmarkStar from "./bookmarks/BookmarkStar"
import MarketBlock from "./MarketBlock"
import NavMenu from "./NavMenu"
import NotificationBell from "./NotificationBell"
import ProductSearch from "./ProductSearch"
import UserMenu from "./UserMenu"

// 44px bar above every page: the Menu button (the only navigation), market
// block, product search, then full-height cells for the bookmark star, task
// status, bell and the avatar with the account menu. The bookmarks bar sits
// under it (AppLayout); the page's own title sits below that, in the page.
// Relative and on top so the Menu panel drops down from its bottom edge over
// the page.
export default function TopBar() {
  return (
    // While the Menu panel is open, the bar moves above pinned page headers
    // (z-50 sticky grid cells) so the panel and its backdrop cover them.
    <div className="relative z-50 has-[nav[aria-label=Main]]:z-60 flex h-11 flex-shrink-0 items-stretch border-b border-border bg-background">
      <NavMenu />
      <MarketBlock />
      <ProductSearch />
      <div className="flex items-stretch [&>:first-child]:border-l-0">
        <BookmarkStar />
        <TaskPill />
        <NotificationBell />
        <UserMenu />
      </div>
    </div>
  )
}
